export default __webpack_public_path__ + "static/media/soehne-web-fett.8ca79e4e.woff2";